import React from "react";
import { Link } from "react-router-dom";

const features = [
  {
    emoji: "🌐",
    title: "Ask in Your Language",
    text: "Type or speak in Hindi, Tamil, Marathi… Eluvent answers in your mother tongue!"
  },
  {
    emoji: "📸",
    title: "Snap & Solve Diagrams",
    text: "Take a photo of any diagram – geometry, circuits, ray optics – and get a step‑by‑step solution."
  },
  {
    emoji: "📝",
    title: "Test Yourself",
    text: "Choose a topic, get fresh AI‑made questions, and see your strong & weak areas."
  },
  {
    emoji: "👨‍🏫",
    title: "Real Teacher Help",
    text: "Stuck? Eluvent will offer to connect you with a certified teacher – or you can ask anytime."
  }
];

const WelcomeModal = ({ onClose }) => (
  <>
    <div onClick={onClose} style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", zIndex: 999
    }} />
    <div style={{
      position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
      width: "90%", maxWidth: 400, backgroundColor: "white", borderRadius: 24,
      padding: "20px", zIndex: 1000, fontFamily: "Nunito, sans-serif",
      boxShadow: "0 20px 40px rgba(0,0,0,0.3)", animation: "modalFadeIn 0.3s ease-out"
    }}>
      <h2 style={{ textAlign: "center", margin: "0 0 16px", color: "#1e293b" }}>✨ What Eluvent Can Do</h2>
      {features.map((f, i) => (
        <div key={i} style={{ display: "flex", gap: 12, marginBottom: 12, alignItems: "center" }}>
          <span style={{ fontSize: 28 }}>{f.emoji}</span>
          <div>
            <h4 style={{ margin: 0, fontSize: 15, color: "#1e293b" }}>{f.title}</h4>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: "#64748b" }}>{f.text}</p>
          </div>
        </div>
      ))}
      <div style={{ textAlign: "center", marginTop: 16 }}>
        <button onClick={onClose} style={{
          padding: "10px 24px", background: "#fca311", color: "white", border: "none",
          borderRadius: 30, fontWeight: 700, fontSize: 14, cursor: "pointer"
        }}>
          Got it! 👍
        </button>
        <Link to="/how-to-use" onClick={onClose} style={{ display: "block", marginTop: 10, color: "#3b82f6", fontSize: 13 }}>
          Learn more in the Guide
        </Link>
      </div>
    </div>
  </>
);

export default WelcomeModal;